'use client';

import dynamic from 'next/dynamic';
import React from 'react';

import { BodyTypesGrouping } from '@/types/home/home.types';
import { NewCarOverview } from '@/types/new-cars/new-cars.types';

const FancyCarousel = dynamic(
  () => import('@/app/_components/fancy-carousel/FancyCarousel'),
  { ssr: false },
);

type Props = {
  body_types: BodyTypesGrouping[];
  new_cars_background?: string | null;
  carsWithOverview?: NewCarOverview[];
  imageHrefBase: string;
  isDealershipPage: boolean;
};

const FancyCarouselDynamic = ({
  imageHrefBase,
  body_types,
  new_cars_background,
  carsWithOverview,
  isDealershipPage,
}: Props) => {
  return (
    <FancyCarousel
      imageHrefBase={imageHrefBase}
      isDealershipPage={isDealershipPage}
      carsWithOverview={carsWithOverview}
      body_types={body_types}
      new_cars_background={new_cars_background ?? ''}
    />
  );
};

export default FancyCarouselDynamic;
